<ng-container *ngIf="!loading; else loadingTemp">
    <div
        *ngIf="selected && !changeMode; else selectTemp"
        fxFlex="0 0 100%"
        class="selected-wrapper"
        fxLayout="row wrap"
    >
        <div fxLayout="column" class="main-wrapper-core" [ngClass]="{ borderless: selected?.scorm_uri }">
            <div class="w-100">
                <div fxFlex="0 0 100%" fxLayout="column wrap" fxLayoutAlign="start center" class="user-manage-tests">
                    <ng-container *ngIf="scormParserPromptStateSub | async; let scormParserPromptState; else: empty">
                        <div class="scorm-block-wrap mt-1">
                            <ng-container *ngIf="selected?.media_id">
                                <app-image-view
                                    class="mt-1 mb-1"
                                    [ignoreThumbnail]="true"
                                    [media_id]="selected?.media_id"
                                    [showImgModalOnClick]="true"
                                    [proportional]="false"
                                >
                                    <button
                                        class="remove-image"
                                        mat-icon-button
                                        color="warn"
                                        type="button"
                                        matTooltip="Remove SCORM"
                                        i18n-matTooltip
                                        (click)="onRemove()"
                                    >
                                        <mat-icon class="md-18">delete_outline</mat-icon>
                                    </button>
                                </app-image-view>
                            </ng-container>
                            <img *ngIf="!selected?.media_id" src="assets/images/Default_scorm_img.png" alt="SCORM" />
                        </div>
                        <div
                            fxLayout="row"
                            fxLayoutAlign="start center"
                            *ngIf="Utils.isOnProgressPromptStatus(scormParserPromptState.status)"
                        >
                            <span>Parsing SCORM package</span>
                            <app-kd-logo-loading size="small"></app-kd-logo-loading>
                        </div>
                        <div
                            fxLayout="row"
                            fxLayoutAlign="start center"
                            *ngIf="scormParserPromptState.status == 'ERROR'"
                        >
                            <span class="error-message">{{ scormParserPromptState.error }}</span>
                            <ng-container *ngTemplateOutlet="retryButton"></ng-container>
                        </div>
                        <div
                            fxLayout="row"
                            fxLayoutAlign="start center"
                            *ngIf="scormParserPromptState.status == 'COMPLETED'"
                        >
                            <span>{{ scormMedia?.filename ?? selected?.scorm?.origin_file ?? 'SCORM package' }}</span>
                        </div>
                    </ng-container>
                    <ng-template #empty>
                        <app-scorm-upload
                            (onScormUploaded)="scormMedia = $event; onScormUploaded($event)"
                        ></app-scorm-upload>
                    </ng-template>
                </div>
            </div>
        </div>
        <div fxLayout="column" fxLayoutGap="10px" *ngIf="resourceItems$ | async as resourceItems">
            <ng-container *ngIf="resourceItems.length > 0">
                <div class="res-bull-label" i18n>SCORM Content</div>
                <div class="res-bull" *ngFor="let item of resourceItems; let index = index">
                    <span class="index">{{ index + 1 }}</span>
                    <span class="res-item-name ecourse" [class.parent]="!item.sco_parent_id">{{ item.title }}</span>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>

<ng-template #selectTemp>
    <app-course-manager-core-add-scorm
        [display]="ResourceBuildingItems.SCORM_LIBRARY"
        (selectChange)="selectResource($event.value); onChangeMode(false)"
        (onCloseView)="onChangeMode(false)"
    ></app-course-manager-core-add-scorm>
</ng-template>

<ng-template #loadingTemp>
    <div fxLayout="row" fxLayoutAlign="left" class="spinner-container">
        <app-kd-logo-loading size="small"></app-kd-logo-loading>
    </div>
</ng-template>
<ng-template #retryButton>
    <button
        *ngIf="selected?.prompt as prompt"
        class="retry-button"
        color="primary"
        type="button"
        fxFlex="0 1 auto"
        mat-icon-button
        matTooltip="Retry SCORM processing"
        i18n-matTooltip
        (click)="onRetry(prompt)"
    >
        <mat-icon class="md-24">refresh</mat-icon>
    </button>
</ng-template>
